import { Dispatch, SetStateAction } from 'react';
import { Flex } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { FieldContainer, PencilWrapper, TextHeading, TextValue } from './../styled';
import {
	DOCUMENT_LIBRARY_ELEMENT_ID,
	makeComplexDataTestId,
} from '@dealstack/shared/tests/testElementIds';

interface Props {
	setEditFieldKey: Dispatch<SetStateAction<string>>;
	label: string;
	fieldKey: string;
	value: string;
	readOnly: boolean;
}

export const TextField = ({ setEditFieldKey, label, fieldKey, value, readOnly }: Props) => {
	return (
		<FieldContainer
			data-testid={makeComplexDataTestId(DOCUMENT_LIBRARY_ELEMENT_ID.FIELD, fieldKey)}
		>
			<Flex justify="space-between" align="center" gap="xs" w="100%">
				<TextHeading>{label}</TextHeading>
				{!readOnly && (
					<PencilWrapper
						data-testid={makeComplexDataTestId(
							DOCUMENT_LIBRARY_ELEMENT_ID.FIELD_EDIT_BUTTON,
							fieldKey
						)}
						onClick={() => setEditFieldKey(fieldKey as string)}
					>
						<Icon variant="pencil-edit" size="xl" color="transparent" />
					</PencilWrapper>
				)}
			</Flex>
			<TextValue
				data-testid={makeComplexDataTestId(
					DOCUMENT_LIBRARY_ELEMENT_ID.FIELD_VALUE,
					fieldKey
				)}
			>
				{value}
			</TextValue>
		</FieldContainer>
	);
};
